(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lounelle-cart-bestsellers"] && !Shopify.designMode) return;
  try {
    /* Native scroll + Shopify-rendered cards. No carousel library or cart-method override. */
if (!customElements.get('lounelle-cart-feed')) {
  const feeds = new WeakMap();
  const CARD = '[data-feed-card]';
  const MAX_CARDS = 48;
  const MAX_PAGE = 8; // At most 96 candidates, including unavailable/excluded products.
  const desktop = window.matchMedia('(min-width: 768px)');

  customElements.define('lounelle-cart-feed', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => { if (this.isConnected && !this.events) this.connect(); });
    }

    connect() {
      this.cart = this.closest('[data-lounelle-native-cart]');
      const seed = this.querySelector('.lounelle-cart-bestsellers__track');
      if (!this.cart || !seed) return;
      let state = feeds.get(this.cart);
      const fresh = this !== state?.owner;
      if (!state || state.key !== this.dataset.feedKey) {
        state = { key: this.dataset.feedKey, cards: new Map(), track: seed,
          next: Number(this.dataset.feedNext) || 0, consumed: Number(this.dataset.feedConsumed) || 0,
          x: 0, y: 0, emptyPages: 0, paused: false, prefetched: false };
        feeds.set(this.cart, state);
      }
      this.state = state;
      state.owner = this;
      if (fresh) {
        state.cartIds = new Set((this.dataset.feedCart || '').split(',').filter(Boolean));
        for (const card of seed.querySelectorAll(CARD)) {
          const old = state.cards.get(card.dataset.feedCard);
          if (!old && state.cards.size < MAX_CARDS) state.cards.set(card.dataset.feedCard, card);
          if (old) {
            const price = old.querySelector('.lounelle-cart-bestseller-card__price');
            const updated = card.querySelector('.lounelle-cart-bestseller-card__price');
            if (price && updated && price.innerHTML !== updated.innerHTML) price.innerHTML = updated.innerHTML;
          }
        }
        if (seed !== state.track) seed.replaceWith(state.track);
      }
      this.track = state.track;
      this.tail = this.track.querySelector('[data-feed-more]');
      this.rail = this.cart.querySelector('[data-lounelle-upsell-desktop-slot]');
      if (!this.tail || !this.rail) return;
      this.restoring = true;
      this.track.scrollLeft = state.x;
      this.rail.scrollTop = state.y;
      const anchor = this.anchor();
      this.renderCards();
      this.restoreAnchor(anchor);
      this.restoreFrame = requestAnimationFrame(() => {
        this.restoreAnchor(anchor);
        this.restoring = false;
        this.remember();
      });
      this.events = new AbortController();
      const signal = this.events.signal;
      this.tail.addEventListener('click', () => {
        state.paused = false;
        state.emptyPages = 0;
        this.load(true);
      }, { signal });
      this.track.addEventListener('scroll', () => this.remember(), { passive: true, signal });
      this.rail.addEventListener('scroll', () => this.remember(), { passive: true, signal });
      desktop.addEventListener('change', () => { this.stop(); this.wake(); }, { signal });
      document.addEventListener('visibilitychange', () => this.wake(), { signal });
      this.gates = new MutationObserver(() => this.wake());
      this.gates.observe(this.cart, { attributes: true, attributeFilter: ['class'] });
      this.gates.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      this.updateTail();
      this.wake();
    }

    allowed() {
      return this.isConnected && this.state.owner === this && !document.hidden &&
        this.cart.classList.contains('is-open') && !this.cart.classList.contains('is-loading') &&
        !document.documentElement.classList.contains('lounelle-upsell-dialog-open');
    }

    wake() {
      if (!this.allowed()) { this.stop(); return; }
      if (this.observing) return;
      this.observing = true;
      if (!('IntersectionObserver' in window)) return; // The translated button remains usable.
      this.visibleObserver = new IntersectionObserver((entries) => {
        this.visible = entries.some((entry) => entry.isIntersecting);
        // One batch ahead only once the recommendations are actually visible.
        if (this.visible && (this.near || !this.state.prefetched)) this.load();
      });
      this.visibleObserver.observe(this);
      this.endObserver = new IntersectionObserver((entries) => {
        this.near = entries.some((entry) => entry.isIntersecting);
        if (this.visible && this.near) this.load();
      }, { root: desktop.matches ? this.rail : this.track,
        rootMargin: desktop.matches ? '0px 0px 480px 0px' : '0px 320px 0px 0px', threshold: 0 });
      this.endObserver.observe(this.tail);
    }

    stop() {
      this.visibleObserver?.disconnect();
      this.endObserver?.disconnect();
      this.observing = false;
      this.visible = false;
      this.near = false;
      if (this.request) {
        this.request.cancelled = true;
        this.request.controller.abort();
        this.request = null;
      }
      this.updateTail();
    }

    remember() {
      if (this.restoring || !this.isConnected || this.state.owner !== this) return;
      this.state.x = this.track.scrollLeft;
      this.state.y = this.rail.scrollTop;
    }

    anchor() {
      const vertical = desktop.matches;
      const root = vertical ? this.rail : this.track;
      if (!root) return null;
      const box = root.getBoundingClientRect();
      // Measure only during a cart refresh, not continuously while scrolling.
      for (const card of this.track.children) {
        if (!card.matches(CARD) || this.state.cartIds.has(card.dataset.feedCard)) continue;
        const rect = card.getBoundingClientRect();
        if (vertical ? rect.bottom > box.top && rect.top < box.bottom : rect.right > box.left && rect.left < box.right) {
          return { card, vertical, offset: vertical ? rect.top - box.top : rect.left - box.left };
        }
      }
      return null;
    }

    restoreAnchor(anchor) {
      if (!anchor?.card.isConnected || anchor.vertical !== desktop.matches || !this.isConnected) return;
      const root = anchor.vertical ? this.rail : this.track;
      const box = root.getBoundingClientRect();
      const rect = anchor.card.getBoundingClientRect();
      const delta = (anchor.vertical ? rect.top - box.top : rect.left - box.left) - anchor.offset;
      if (anchor.vertical) root.scrollTop += delta;
      else root.scrollLeft += delta;
    }

    renderCards() {
      const state = this.state;
      for (const card of state.cards.values()) {
        if (state.cartIds.has(card.dataset.feedCard)) card.remove();
      }
      let cursor = this.track.firstElementChild;
      const ordered = [...state.cards.values()].sort((a, b) => Number(a.dataset.feedRank) - Number(b.dataset.feedRank));
      for (const card of ordered) {
        if (state.cartIds.has(card.dataset.feedCard)) continue;
        if (card === cursor) cursor = cursor.nextElementSibling;
        else this.track.insertBefore(card, cursor || this.tail);
      }
    }

    updateTail() {
      if (!this.tail || !this.state) return;
      this.tail.hidden = !this.state.next || this.state.next > MAX_PAGE || this.state.cards.size >= MAX_CARDS;
      this.tail.disabled = Boolean(this.request);
      this.tail.setAttribute('aria-busy', String(Boolean(this.request)));
      this.tail.classList.toggle('is-loading', Boolean(this.request));
    }

    async load(manual = false) {
      const state = this.state;
      if (!this.allowed() || this.request || !state.next || state.next > MAX_PAGE ||
        state.cards.size >= MAX_CARDS || (!manual && state.paused)) return;
      const page = state.next;
      const url = new URL(this.dataset.feedUrl, location.origin);
      if (url.origin !== location.origin) return;
      url.search = '';
      url.searchParams.set('section_id', 'api-cart-bestsellers');
      url.searchParams.set('page', String(page));
      url.searchParams.set('sort_by', this.dataset.feedSort);
      const preview = new URLSearchParams(location.search).get('preview_theme_id');
      if (preview && /^\d+$/.test(preview)) url.searchParams.set('preview_theme_id', preview);
      const request = { controller: new AbortController(), cancelled: false };
      this.request = request;
      const timer = setTimeout(() => request.controller.abort(), 12000);
      this.updateTail();
      try {
        const response = await fetch(url, { credentials: 'same-origin', signal: request.controller.signal });
        if (!response.ok) throw new Error('Feed request failed');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const batch = html.querySelector('[data-feed-page]');
        if (!batch || batch.dataset.feedKey !== state.key || Number(batch.dataset.feedPage) !== page) {
          throw new Error('Unexpected collection or market');
        }
        if (request.cancelled || !this.allowed()) return;
        const candidates = [...batch.querySelectorAll(CARD)];
        const before = state.cards.size;
        let warmed = 0;
        for (const card of candidates) {
          if (state.cards.size >= MAX_CARDS) break;
          if (Number(card.dataset.feedRank) < state.consumed || state.cartIds.has(card.dataset.feedCard)) continue;
          if (!state.cards.has(card.dataset.feedCard)) {
            state.cards.set(card.dataset.feedCard, card);
            // Warm just the first two new thumbnails; all other images stay lazy.
            if (warmed++ < 2 && !navigator.connection?.saveData) {
              const image = card.querySelector('img');
              if (image) { image.loading = 'eager'; image.fetchPriority = 'low'; }
            }
          }
        }
        const next = Number(batch.dataset.feedNext) || 0;
        state.next = next > page && next <= MAX_PAGE ? next : 0;
        state.consumed = Math.max(state.consumed, page * 12);
        state.prefetched = true;
        state.emptyPages = state.cards.size === before ? state.emptyPages + 1 : 0;
        state.paused = state.emptyPages >= 2; // Do not scan a sold-out collection in a tight loop.
        this.renderCards();
      } catch (error) {
        if (!request.cancelled && this.isConnected && state.owner === this) {
          state.paused = true; // A manual retry never blocks checkout or the existing cards.
        }
      } finally {
        clearTimeout(timer);
        if (this.request === request) {
          this.request = null;
          this.updateTail();
          this.near = false;
          if (this.observing && this.endObserver) {
            this.endObserver.unobserve(this.tail);
            if (!this.tail.hidden) this.endObserver.observe(this.tail);
          }
        }
      }
    }

    disconnectedCallback() {
      this.stop();
      this.events?.abort();
      this.events = null;
      this.gates?.disconnect();
      cancelAnimationFrame(this.restoreFrame);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
